import { Slider } from 'antd';
import React, { useState } from 'react'
import styled from 'styled-components';
import { numberToPastDate } from '../../pages/utils';

type VALUE_TYPE = "NUMBER" | "DATE";

type CustomFormItemProps = {
    value?: [number, number];
    minVal: number,
    initialMinVal?: number,
    initialMaxVal?: number,
    maxVal: number,
    onChange?: (value: [number, number]) => void,
    disabled?: boolean,
    valueType: VALUE_TYPE,
    singleSidedDeclarationSlider?: boolean
};

const formatMonthTooltip = (valueType: VALUE_TYPE, stuff?: number) => {
    switch (valueType) {
        case 'DATE':
            const pastDate = numberToPastDate(stuff);

            if (pastDate) {
                return pastDate.getMonth() + 1 + "/" + pastDate.getFullYear();
            }
            break;
        case 'NUMBER':
            return stuff;
        default:
            return stuff;
    }
};

const SliderLabelsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-content: space-around;
`;

export default function CustomSliderWithLabels(props: CustomFormItemProps) {
    const [sliderVal, setSliderVal] = useState<[number, number]>([
        props.initialMinVal !== undefined ? props.initialMinVal : props.minVal,
        props.initialMaxVal !== undefined ? props.initialMaxVal : props.maxVal
    ]);

    const onSliderChange = (val: any) => {
        setSliderVal(val);

        if (props.onChange) {
            props.onChange(val);
        }
    };

    const onSliderChangeReverse = (val: number) => {
        const minAndMax: [number, number] = [-val, props.maxVal];

        setSliderVal(minAndMax);

        if (props.onChange) {
            props.onChange(minAndMax);
        }
    };

    return <>
        {
            props.singleSidedDeclarationSlider &&
            <Slider disabled={props.disabled} tooltipVisible={false} range={false} reverse={true} min={props.maxVal} max={-props.minVal} defaultValue={-sliderVal[0]} onChange={onSliderChangeReverse} />
        }
        {
            !props.singleSidedDeclarationSlider &&
            <Slider disabled={props.disabled} tooltipVisible={false} range={true} min={props.minVal} max={props.maxVal} defaultValue={sliderVal} onChange={onSliderChange} />
        }
        <SliderLabelsContainer>
            <label>{formatMonthTooltip(props.valueType, sliderVal[0])}</label>
            <span style={{ "margin": "0 4px 0 4px" }}>-</span>
            <label>{formatMonthTooltip(props.valueType, sliderVal[1])}</label>
        </SliderLabelsContainer>
    </>;
}